<h4 class="fw-bold py-3 mb-4">Fetrapi Members</h4>
<p> Obtain a list of all <strong>Fetrapi members</strong> and contact details.</p>

<div *ngIf="!isLoaded" class="spinner-border" role="status">
  <span class="visually-hidden">Loading...</span>
</div>

<!--<table *ngIf="isLoaded" class="table table-striped">
  <thead>
    <tr>
      <th>Id</th>
      <th>Name</th>
      <th>Emails</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let member of members">
      <td>{{member.memberId}}</td>
      <td>{{member.memberName}}</td>
      <td>{{member.memberEmails}}</td>
    </tr>
  </tbody>
</table>-->

<table *ngIf="isLoaded" class="table table-striped">
  <thead>
    <tr>
      <th>Time</th>
      <th>Member</th>
      <th>MemberOf</th>
      <th>ActorId</th>
      <th>Log Type</th>
      <th>Log SubType</th>
      <th>DatasetId</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let log of logs">
      <td>{{appService.utcToLocal(getLogDate(log))}}</td>
      <td>{{log.memberName}}</td>
      <td>{{log.memberOf}}</td>
      <td>{{log.actorId}}</td>
      <td>{{log.logEntryType}}</td>
      <td>{{log.logMessage}}</td>
      <td>{{log.datasetId}}</td>
    </tr>
  </tbody>
</table>
